




































































import Vue from 'vue'
import Links from './Links.vue'


export default Vue.extend({
    name: 'Select',
    components:{
        Links
    },
    metaInfo: {
        title: 'Roof Tie-Down Retrofit',
        meta : [
            {
                name: 'description',
                content : 'Select a house type, wind region and other features see the construction details for a roof tie down retrofit for your house.'
            },
            {
                name: 'keywords',
                content : 'retrofitting, technical drawings, retrofitting details, cyclone, weather, storm, protection'
            }
        ]
    },
    data: () => ({
        step: 1,
        step1: [
            {
                title: "Queenslander",
                image: "queenslander-2.jpg",
                text: "Timber framed house"
            },
            {
                title: "Low Pitch Roof",
                image: "queenslander.jpg",
                text: "House with low pitch roof"
            },
            {
                title: "Low-set",
                image: "low-set.jpg",
                text: "Low-set with brick veneer"
            },
            {
                title: "Low-set Double Brick",
                image: "brick-house.jpg",
                text: "Low-set double brick"

            }
        ]
    }),
    computed: {
        currentTitle () {
            switch (this.step) {
                case 1: return 'What type is your house?'
                case 2: return 'Select a component of your house'
                default: return 'Retrofit Detail'
            }
        },
    },
})
